import { ApolloClient, InMemoryCache, from, HttpLink, ApolloLink } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { createSubscriptionHandshakeLink } from "aws-appsync-subscription-link"
import { createAuthLink, AuthOptions} from "aws-appsync-auth-link"

const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) => {
        console.log(
          `[GraphQL error] Message: ${message}, Location: ${locations}, Path: ${path}`,
        );
        return forward(operation);
      });
    }
    if (networkError) {
      console.log(`[Network error] ${networkError}`);
    }
  },
);

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
});



const url = process.env.REACT_APP_GRAPHQL_ENDPOINT!
const region = process.env.REACT_APP_GRAPHQL_REGION!
const auth: AuthOptions = {
  type: "API_KEY",
  apiKey: process.env.REACT_APP_GRAPHQL_APIKEY!,
}

const oneAheadLink = ApolloLink.from([
  createAuthLink({
    url: process.env.REACT_APP_ONE_AHEAD_GRAPHQL_ENDPOINT!,
    region,
    auth: {
      type: "API_KEY",
      apiKey: process.env.REACT_APP_ONE_AHEAD_GRAPHQL_APIKEY!,
    }
  }),
  createSubscriptionHandshakeLink({
    url: process.env.REACT_APP_ONE_AHEAD_GRAPHQL_ENDPOINT!,
    region,
    auth: {
      type: "API_KEY",
      apiKey: process.env.REACT_APP_ONE_AHEAD_GRAPHQL_APIKEY!,
    }
  }),
])

const awsLink = ApolloLink.from([
  createAuthLink({
    url,
    region,
    auth,
  }),
  createSubscriptionHandshakeLink({
    url,
    region,
    auth,
  })
])

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.split(
    (operation) => {
      console.log(operation.getContext()['clientName'])
      return operation.getContext()['clientName'] === 'oneAhead'
    },
    oneAheadLink,
    awsLink,
  ),
});

export default client;
